import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const StudentCodeLogin = ({ onLogin, isLoading }) => {
  const navigate = useNavigate();
  const [loginCode, setLoginCode] = useState('');
  const [error, setError] = useState('');

  // Mock student login codes
  const mockStudentCodes = {
    'STU001': { name: 'Alex Silva', belt: 'Blue Belt' },
    'STU002': { name: 'Maria Santos', belt: 'White Belt' },
    'STU003': { name: 'João Oliveira', belt: 'Purple Belt' }
  };

  const handleCodeChange = (e) => {
    const value = e?.target?.value?.toUpperCase();
    setLoginCode(value);
    
    if (error) {
      setError('');
    }
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    
    if (!loginCode?.trim()) {
      setError('Please enter your student code');
      return;
    }

    const studentData = mockStudentCodes?.[loginCode];
    
    if (!studentData) {
      setError('Invalid student code. Please try: STU001, STU002, or STU003');
      return;
    }

    // Simulate login process
    if (onLogin) {
      onLogin('student', studentData);
    }

    // Navigate to student portal
    navigate('/student-portal');
  };

  return (
    <div className="w-full max-w-md">
      <div className="text-center mb-6">
        <div className="w-16 h-16 bg-accent rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="QrCode" size={32} color="#1A1A1A" />
        </div>
        <h3 className="text-xl font-semibold text-foreground mb-2">
          Student Portal Access
        </h3>
        <p className="text-sm text-muted-foreground">
          Enter your unique student code to access your portal
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Student Code Input */}
        <Input
          label="Student Code"
          type="text"
          placeholder="Enter your code (e.g., STU001)"
          value={loginCode}
          onChange={handleCodeChange}
          error={error}
          required
          disabled={isLoading}
          className="text-center text-lg font-mono tracking-wider"
        />

        {/* Access Button */}
        <Button
          type="submit"
          variant="default"
          fullWidth
          loading={isLoading}
          disabled={isLoading}
          iconName="ArrowRight"
          iconPosition="right"
        >
          Access Portal
        </Button>

        {/* Help Text */}
        <div className="text-center">
          <p className="text-xs text-muted-foreground">
            Don't have your student code? Contact the academy reception.
          </p>
        </div>
      </form>
    </div>
  );
};

export default StudentCodeLogin;